import { createContext } from "react";

export const SecureSettingsContext = createContext({
  site: {},
  setSite: () => {},
  loadSite: () => {}
})